import { NgModule } from '@angular/core';
import { SortArrayByParameterPipe } from './sort-array-by-parameter.pipe';



@NgModule({
  declarations: [SortArrayByParameterPipe],
  exports: [SortArrayByParameterPipe]
})
export class SortArrayByParameterModule { }
